/**
 * Image Slider
 */

import Flickity from 'flickity';

const objectSlider = {
    cfg: {
        content: document.querySelector('.js-objectSlider-content'),
        slider: '.js-objectSlider',
        sliderOptions: {
            cellAlign: 'center',
            // contain: true,
            draggable: true,
            friction: 1,
            lazyLoad: 2,
            selectedAttraction: 0.1,
            groupCells: false,
            setGallerySize: true,
            imagesLoaded: true,
            prevNextButtons: true,
            pageDots: false,
            wrapAround: true,
            on: {
                ready: (index) => {
                    const wrapper = document.querySelector('.js-objectSlider-content');
                    // eslint-disable-next-line
                    const targets = document.querySelector('.js-objectSlider-content').querySelectorAll('div');
                    targets[0].classList.add('is-selected');
                    wrapper.setAttribute('style',`height:${targets[0].clientHeight}px`);
                },
                change: (index) => {
                    const wrapper = document.querySelector('.js-objectSlider-content');
                    // eslint-disable-next-line
                    const targets = wrapper.querySelectorAll('.js-objectSlider-contentInner');
                    targets.forEach((target) => {
                        target.classList.remove('is-selected');
                    });
                    targets[index].classList.add('is-selected');
                    wrapper.setAttribute('style',`height:${targets[index].clientHeight}px`);
                }
            }
            // watchCSS: true
        },
        isSelected: '.is-selected'
    },

    init() {
        window.addEventListener('load', () => {
            const sliders = [...document.querySelectorAll(this.cfg.slider)];
            if (sliders) {
                sliders.forEach((slider) => {
                    const flkty = new Flickity(slider, this.cfg.sliderOptions);
                    flkty.resize();

                    setTimeout(() => {
                        flkty.resize();
                        slider.classList.add('is-ready');
                    }, 1000);
                });
            }
        });
    }
};

export default objectSlider;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/objectSlider/_script.js